import React, {useState, useEffect,useMemo} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { Edit, RemoveRedEye } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function Mensalidades() {
    const [mensalidadesMesAno, setMensalidadesMesAno] = useState([]);
    const [mensalidadesAno, setMensalidadesAno] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente

    const [anoAtual, setAnoAtual] = useState(sessionStorage.anoMensalidade ? sessionStorage.anoMensalidade : new Date().getFullYear());
    const esseAno = new Date().getFullYear();
    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth() + 1;

    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const toggleLogoff = () => {
        localStorage.clear();
        localStorage.setItem('loggedIn', false);
        localStorage.removeItem('user');
        sessionStorage.clear();
    };
    
    //array de anos para select
    const [yearsSelect, setYearsSelect] = useState([]);
    // Gerar os anos para o select, começando do ano atual e retrocedendo até 2021
    const years = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const startYear = 2021;
        const yearsArray = [];

        yearsArray.push('TODOS'); // Opção para todos os anos
        // Adiciona o ano atual e retrocede até 5 anos ou o limite de 2021
        for (let i = 0; i <= 30; i++) {
        const year = currentYear - i;
        if (year >= startYear) {
            yearsArray.push(year);
        } else {
            break; // Para o loop se for menor que 2021
        }
        }
        return yearsArray;
    }, []); // Executa apenas uma vez
 
    //açao para setar o ano selecionado no select para exibição da lista por mês
    function handleSelectAno(event) {
        sessionStorage.anoMensalidade = event.target.value
        setAnoAtual(sessionStorage.anoMensalidade)
        handleCarregarAno(sessionStorage.anoMensalidade);
    }
    //não executa ação de cadastro, apenas direciona para a página de lançamentos por mês
    function handleNovoCadastro() {
        //setModalOpen(false);
    }

    //ação para setar o status selecionado no select para exibição da lista por status
    function handleSelectStatusChange(event) {
        sessionStorage.selectStatusMensalidades = event.target.value
        setSelectStatus(sessionStorage.selectStatusMensalidades)
    }

    function handleRetornaMes(mes) {
      switch (mes) {
        case '1':
          return 'Janeiro';
        case '2':
          return 'Fevereiro';
        case '3':
          return 'Março';
        case '4':
          return 'Abril';
        case '5':
          return 'Maio';
        case '6':
          return 'Junho';
        case '7':
          return 'Julho';
        case '8':
          return 'Agosto';
        case '9':
          return 'Setembro';
        case '10':
          return 'Outubro';
        case '11':
          return 'Novembro';
        case '12':
          return 'Dezembro';
        default:
          return mes;
      }
    }

    // Define o ano atual como o primeiro da lista (ano mais recente)
    useEffect(() => {
        setYearsSelect(years);
        setAnoAtual(anoAtual); // Mantém o ano atual como o valor inicial
        //setAnoAtual(years[0]);
      }, [years]);
       
    //carrega os dados de resumos das mensalidades por ano para o gráfico
    useEffect(() => {
        setIsLoadingMOD(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        const dados = {
            "mslAno": anoAtual
        }

        axios.post(process.env.REACT_APP_API_URL +
         "/routes.php?metodo=obtemResumoMensalidadesAno", 
         dados, 
         {
            headers: {
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
            }}
        )
        .then(response => {
            setMensalidadesAno(response.data);
            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao obter os dados de mensalidades por ano:', error);
            setIsLoadingMOD(false);
        });
    }, [anoAtual]);

    //carrega os dados de resumos das mensalidades por mês para o gráfico
    useEffect(() => {
        setIsLoadingMOD(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        const dados = {
            "mslAno": anoAtual
        }

        axios.post(process.env.REACT_APP_API_URL +
         "/routes.php?metodo=obtemResumoMensalidadesMesAno", 
         dados, 
         {
            headers: {
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
            }}
        )
        .then(response => {
            setMensalidadesMesAno(response.data);
            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao obter os dados de mensalidades por mês:', error);
            setIsLoadingMOD(false);
        });
    }, [anoAtual]);

    //carrega os dados de resumos das mensalidades por mês para o gráfico
    function handleCarregarAno(ano) {
        setIsLoadingMOD(true);
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

        const dados = {
            "mslAno": ano
        }
//console.log("Dados enviados para a API:", dados);
        axios.post(process.env.REACT_APP_API_URL +
         "/routes.php?metodo=obtemResumoMensalidadesMesAno", 
         dados, 
         {
            headers: {
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
            }}
        )
        .then(response => {
            setMensalidadesMesAno(response.data);
            setIsLoadingMOD(false);
        })
        .catch(error => {
            console.error('Erro ao obter os dados de mensalidades por mês:', error);
            setIsLoadingMOD(false);
        });
    }


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Mensalidades",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de navegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >FINANCEIRO</label>
                        <label className='labelSubTitulo'>Histórico e Lançamento de Mensalidades</label>
                    </div>

                    {/* Pesquisa filtro e Novo */}
                    <div className="containerBarraPesquisa d-flex flex-wrap align-items-center justify-content-space-between">
                        
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        // <Link to={`/Mensalidade/${anoAtual === 'TODOS' ? esseAno : anoAtual}/${mesAtual}`}> 
                            <button className="buttonModalPadrao" onClick={() => navigate(`/Mensalidade/${anoAtual === 'TODOS' ? esseAno : anoAtual}/${mesAtual}`)}>
                                LANÇAMENTO MENSAL
                            </button>
                        // </Link> 
                        ) : ('')}

                        {/* <Link to={`/MapaAnual`}>  */}
                            <button className="buttonModalPadrao" onClick={() => navigate(`/MapaAnual`)}>
                                MAPA ANUAL
                            </button>
                        {/* </Link> */}

                        {/* ano para exibição da lista por mês */}
                        <select className="selectStatusPesquisa"
                            name="selectAnoMensalidade"
                            id="selectAnoMensalidade"
                            onChange={event => {
                                handleSelectAno(event);
                            }}
                        >
                            {yearsSelect.map((year) => (
                                <option key={year} value={year} selected={parseInt(anoAtual) === year}>{year}</option>
                            ))}
                            
                        </select>
                    </div>
                </div>

                {/* tabela de resumo ano */}
                <div style={{ marginTop: '10px', marginBottom: '20px', textAlign: 'left', marginLeft: '50px' }}>
                    <h3 className="tituloTabela">
                        Resumo de Mensalidades por Ano
                    </h3>
                </div>
                <div className="tabelaPadrao">
                    <table className="tabelaDados">
                        <thead>
                            <tr>
                                <th className='tdAlignLeft pl2' >Ano</th>
                                <th className='tdAlignCenter' >Registros</th>
                                <th className='tdAlignRight' >Valor Total</th>
                            </tr>
                        </thead>
                        <tbody>
                        
                        {isLoadingMOD ? (
                            <tr>
                                <td colSpan="3" style={{ width: "100%", textAlign: "center"}}>
                                    <CircularProgress />
                                </td>
                            </tr>
                            // <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                            //     <CircularProgress />
                            // </div>
                            ) : (
                                mensalidadesAno
                                .filter((item) => {
                                    if (anoAtual !== 'TODOS' && item.mslAno.toString() === anoAtual.toString()) {
                                        return item;
                                    } else if (anoAtual === 'TODOS') {
                                        return item;
                                    }
                                    return false;
                                })
                                .map((item) => (
                                    <tr key={item.mslAno} onClick={() => setAnoAtual(item.mslAno)} style={{cursor: 'pointer'}}>
                                        <td className='tdAlignLeft' >{<RemoveRedEye  style={{width: '22px', marginBottom: '-6px', marginRight: '4px', color: '#f27f05'}}/>}{item.mslAno}</td>
                                        <td className='tdAlignCenter' >{item.totalMensalidades}</td>
                                        <td className='tdAlignRight' >R$ {item.valorTotal}</td>
                                    </tr>
                                ))  
                            )}
                        </tbody>
                    </table>
                    {isLoadingMOD && <p>Carregando...</p>}
                </div>

                {/* tabela de resumo mês */}
                <div style={{ marginTop: '10px', marginBottom: '20px', textAlign: 'left', marginLeft: '50px' }}>
                    <h3 className="tituloTabela">
                        Resumo de Mensalidades por Mês - Ano: {anoAtual}
                    </h3>
                </div>

                <div className="tabelaPadrao">
                    <table className="tabelaDados">
                        <thead>
                            <tr>
                                <th className='tdAlignLeft pl2' >Mês</th>
                                <th className='tdAlignCenter' >Registros</th>
                                <th className='tdAlignRight' >Valor Total</th>
                            </tr>
                        </thead>
                        <tbody>
                        {isLoadingMOD ? (
                            <tr>
                                <td colSpan="3" style={{ width: "100%", textAlign: "center"}}>
                                    <CircularProgress />
                                </td>
                            </tr>
                            ) : (
                                mensalidadesMesAno
                                .filter((item) => {
                                    if (anoAtual !== 'TODOS' && item.mslAno.toString() === anoAtual.toString()) {
                                        return item;
                                    } else if (anoAtual === 'TODOS') {
                                        return item;
                                    }
                                    return false;
                                })
                                .map((item) => (
                                    <tr key={`${item.mslAno}-${item.mslMes}`} onClick={() => navigate(`/Mensalidade/${item.mslAno}/${item.mslMes}`)} style={{cursor: 'pointer'}}>
                                        <td className='tdAlignLeft' >{<Edit style={{width: '18px', marginBottom: '-6px', marginRight: '4px', color: '#f27f05'}} />}{handleRetornaMes(item.mslMes)}/{item.mslAno}</td>
                                        <td className='tdAlignCenter' >{item.totalMensalidades}</td>
                                        <td className='tdAlignRight' >R$ {item.valorTotal}</td>
                                    </tr>
                                ))  
                            )}
                            </tbody>
                        </table>
                    {isLoadingMOD && <p>Carregando...</p>}
                </div>
            </main>
        </div>
        
    );
}

export default Mensalidades;